import { render, staticRenderFns } from "./PropertyListingCount.vue?vue&type=template&id=669f7060"
import script from "./PropertyListingCount.vue?vue&type=script&lang=js"
export * from "./PropertyListingCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports